// context/CategoryContext.tsx
import React, { createContext, useContext, useEffect, useState } from "react";

export interface CustomCategory {
  value: string;
  label: string;
}

interface CustomCategoryContextType {
  categories: CustomCategory[];
  addCategory: (newCategory: string) => void;
  deleteCategory: (index: number) => void;
  /*   resetCategories: () => void; */
}

const CustomCategoryContext = createContext<
  CustomCategoryContextType | undefined
>(undefined);

export const useCustomCategories = () => {
  const context = useContext(CustomCategoryContext);
  if (!context) {
    throw new Error("useCategories must be used within a CategoryProvider");
  }
  return context;
};

export const CustomCategoryProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [categories, setCategories] = useState<CustomCategory[]>([]);

  useEffect(() => {
    const stored = localStorage.getItem("customCategories");
    if (stored) {
      setCategories(JSON.parse(stored));
    } else {
      const defaultCats: CustomCategory[] = [
        { label: "Auto", value: "Auto" },
        { label: "Bildung", value: "Bildung" },
        { label: "Fitness", value: "Fitness" },
        { label: "Freizeit", value: "Freizeit" },
        { label: "Garten", value: "Garten" },
        { label: "Gehalt", value: "Gehalt" },
        { label: "Geschenke", value: "Geschenke" },
        { label: "Gesundheit", value: "Gesundheit" },
        { label: "Haustiere", value: "Haustiere" },
        { label: "Haushaltswaren", value: "Haushaltswaren" },
        { label: "Hobby", value: "Hobby" },
        { label: "Kleidung", value: "Kleidung" },
        { label: "Lebensmittel", value: "Lebensmittel" },
        { label: "Miete", value: "Miete" },
        { label: "Reisen", value: "Reisen" },
        { label: "Restaurant", value: "Restaurant" },
        { label: "Shopping", value: "Shopping" },
        { label: "Sonstiges", value: "Sonstiges" },
        { label: "Sparen", value: "Sparen" },
        { label: "Unterhaltung", value: "Unterhaltung" },
        { label: "Versicherungen", value: "Versicherungen" },
        { label: "Verträge/Abos", value: "Verträge/Abos" },
      ];
      setCategories(defaultCats);
      localStorage.setItem("customCategories", JSON.stringify(defaultCats));
    }
  }, []);

  const addCategory = (newCategory: string) => {
    const formatted = { label: newCategory, value: newCategory };
    const updated = [...categories, formatted];
    setCategories(updated);
    localStorage.setItem("customCategories", JSON.stringify(updated));
  };

  const deleteCategory = (index: number) => {
    const updated = [...categories];
    updated.splice(index, 1);
    setCategories(updated);
    localStorage.setItem("customCategories", JSON.stringify(updated));
  };

  /*   const resetCategories = () => {
    setCategories(defaultCategories);
    localStorage.setItem("customCategories", JSON.stringify(defaultCategories));
  }; */

  return (
    <CustomCategoryContext.Provider
      value={{ categories, addCategory, deleteCategory }}
    >
      {children}
    </CustomCategoryContext.Provider>
  );
};
